/**
 * Check if value is null or undefined
 * @param value any
 * @returns boolean
 */
const isNil = (value?: any): value is null | undefined => value == null;

export default isNil;
